export enum DisplayCurrencyMode {
  ETH = "ETH",
  WETH = "WETH",
  DOLLAR = "USD",
  MTC = "MTC",
  WMTC = "WMTC",
}
